import script from "./captionsEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./captionsEdit.vue?vue&type=script&setup=true&lang=ts"

import "./captionsEdit.vue?vue&type=style&index=0&id=2837edc4&scoped=true&lang=scss"
import "./captionsEdit.vue?vue&type=style&index=1&id=2837edc4&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2837edc4"]])

export default __exports__